import { snakeCase } from 'lodash';

import { GoogleMapMarker, GoogleMapMarkerType, GoogleMapPopup } from '@lib/geo/google/map';
import { COLORS, THEME } from '@lib/ui/theme';
import { FsLprCamera } from '@lib/vehicle-intelligence';

export class LprCameraMarker extends GoogleMapMarker {
  public infoWindow: GoogleMapPopup;

  private _icons = {
    'VIGILANT LEARN ALPR': {
      fontIcon: 'Icon_Vigilant',
      fontSet: 'fs',
    },
    'FS ALPR': {
      fontIcon: 'Icon_FS',
      fontSet: 'fs',
    },
    'GENETEC ALPR': {
      fontIcon: 'Icon_Genetec',
      fontSet: 'fs',
    },
    'GENETEC SHARPV ALPR': {
      fontIcon: 'Icon_Genetec',
      fontSet: 'fs',
    },
    'GENETEC SHARP3 ALPR': {
      fontIcon: 'Icon_Genetec',
      fontSet: 'fs',
    },
    'REKOR ALPR': {
      fontIcon: 'Icon_Rekor',
      fontSet: 'fs',
    },
    DroneSense: {
      fontIcon: 'Icon_DroneSense',
      fontSet: 'fs',
    },
  };

  constructor(public readonly camera: FsLprCamera) {
    super({
      id: `lpr-camera-${snakeCase(camera.id)}-${camera.integrationType}}`,
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: camera.position.coordinates,
      title: camera.id,
      icon: {
        fontSet: 'fs',
        fontIcon: 'FususALPR',
      },
      style: {
        scale: 0.9,
        strokeWeight: 1.5,
        strokeOpacity: 1,
        fillOpacity: 1,
        fillColor: '#fff',
      },
    });

    if (this._icons[camera.type]) {
      this.setIcon(this._icons[camera.type]);
    }

    this.setStyle({
      strokeColor: this.camera.up ? THEME.success : COLORS['amber-300'],
    });
  }
}
